import { Component, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { AcceptOrStartCallAction, ChangeRequestUserDecision } from 'src/app/store/samwin/client-phone/client-phone.actions';
import { ClientPhoneState } from 'src/app/store/samwin/client-phone/client-phone.state';
import { DialTarget, NextDialTargetState } from 'src/app/store/samwin/next-dial-target/next-dial-target.state';
import { SamwinLinesStateSelector } from 'src/app/store/samwin/samwin-lines/samwin-lines.selector';
import { IShortCallInfo } from 'src/app/store/samwin/samwin-lines/samwin-lines.state';

@Component({
   selector: 'samweb-accept-or-dial-dialog',
   templateUrl: './accept-or-dial-dialog.component.html',
   styleUrls: ['./accept-or-dial-dialog.component.scss'],
})
export class AcceptOrDialDialogComponent implements OnInit {
   @Select(ClientPhoneState.isAcceptOrStartCallDecisionRequired)
   public isAcceptOrStartCallDecisionRequired$: Observable<boolean>;

   @Select(NextDialTargetState.nextDialTarget)
   public nextDialTarget$: Observable<DialTarget>;

   @Select(SamwinLinesStateSelector.getCurrentCallShortInfo)
   public callInfo$: Observable<IShortCallInfo>;

   public phoneAnswerIcon: IconDefinition = WellKnownIconsEnum.CALLING_ANSWER.icon;
   public dialArrowIcon: IconDefinition = WellKnownIconsEnum.CALLING_DIAL_ARROW.icon;

   constructor(private store: Store) {}

   ngOnInit(): void {}

   accept(): void {
      this.store.dispatch(new AcceptOrStartCallAction('accept'));
   }

   dial(): void {
      this.store.dispatch(new AcceptOrStartCallAction('dial'));
   }

   cancel() {
      this.store.dispatch(new ChangeRequestUserDecision(false));
   }
}
